var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TemplateTable',{attrs:{"title":_vm.$t('menu.resales-credited'),"text":_vm.$t('resalesCredited.description'),"name":"resalesCredited","url":_vm.$listRoutes.resalesCredited,"table":_vm.resalesCredited,"filters":_vm.resalesCreditedFilters,"fields":_vm.fields,"defaultFilters":_vm.defaultCreatedAtFilter,"requireFilters":true,"useCurrency":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }